import { sel, strMap, constant, range, head } from 'fxjs/es';

export const makeBlindUser = (user) => {
  const name = sel('name', user);
  const len = sel('length', name);
  const len2 = Math.min(Math.round(len / 3), 3);
  const masked_name = name
    ? name.substr(0, Math.min(len - len2, 4)) + strMap(constant('*'), range(len2))
    : 'Guest';

  const email = sel('email', user);
  const [username, domain] = email ? email.split('@') : [];
  const STATIC_STAR_NUMBER = 5;

  if (!domain) {
    return {
      email: email ? `${head(username)}${strMap(constant('*'), range(STATIC_STAR_NUMBER))}` : masked_name,
    };
  }

  return {
    id: user.id,
    email: email
      ? `${head(username)}${strMap(constant('*'), range(STATIC_STAR_NUMBER))}@${domain}`
      : masked_name,
  };
};
